import auth from 'middlewares/auth';
import { actingHeaders } from 'helpers/actingProducer';
import { getInstallId, INSTALL_HEADER } from 'helpers/installId';

const headers = (isPublic) => {
    // Identifica o visitante no registro de buscas da API (sem login não há outro).
    const base = { ...commonHeaders, [INSTALL_HEADER]: getInstallId() };

    if (tokenWithValidations(isPublic)) {
        return {
            ...base,
            ...actingHeaders(),
            Authorization: `Bearer ${auth.getToken()}`
        }
    }

    return base;
}

const tokenWithValidations = (isPublic) => {
    return !isPublic && auth.getToken();
}

const commonHeaders = {
    accept: 'application/json',
    'Content-Type': 'application/json',
}

export default headers;
